import type { TFunction } from 'i18next';
import type { WeekProgressSummary } from '../../redux/selectors/weekProgress';

/**
 * Build the headline string shown at the top of WeekProgressStrip.
 * Pure function — extracted so it can be unit-tested without rendering
 * the React Native component.
 */
export function buildHeadline(s: WeekProgressSummary, t: TFunction): string {
  return (
    t('thisWeek.progress.cooked', { cooked: s.cooked, total: s.total }) +
    (s.skipped > 0 ? ` · ${t('thisWeek.progress.skipped', { skipped: s.skipped })}` : '') +
    (s.upcoming > 0 ? ` · ${t('thisWeek.progress.toCome', { upcoming: s.upcoming })}` : '')
  );
}
